"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverLimitsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconSlider_1 = require("../../../components/FalconSlider");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var FalconAccordion_1 = require("../../../components/FalconAccordion");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var CoverLimitsWidget = exports.CoverLimitsWidget = /** @class */ (function (_super) {
    __extends(CoverLimitsWidget, _super);
    function CoverLimitsWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maxValue = 50000;
        _this.renderCheckmarks = function () {
            return (React.createElement("ul", { className: "list-unstyled bullet-points font-weight-extra-light" },
                React.createElement("li", { className: "media mb-1 mt-3" },
                    React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                    React.createElement("div", { className: "mb-0" },
                        React.createElement("b", null, "\u00A32,000 for any single item inside your home (unless specified)."),
                        " Your furniture is automatically covered, you don\u2019t need to specify it")),
                React.createElement(FalconAccordion_1.FalconAccordion, { toggleHidden: React.createElement("div", { className: "toggle" }, "+ Show more"), toggleShown: React.createElement("div", { className: "toggle" }, "- Show less") },
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "d-flex" },
                            React.createElement("div", { className: "mr-2" },
                                React.createElement("b", null, "\u00A310,000 for damage to your landlord\u2019s fixtures and fittings")),
                            React.createElement(InfoModal_1.InfoModal, { title: "What are fixtures and fittings?", className: "mt-2 ml-0" },
                                React.createElement("p", null, "Fixtures and fittings are parts of the property which can\u2019t be moved around. A list of fixtures and fittings and their condition will be noted in the inventory from your landlord, but in a nutshell, fixtures and fittings usually include things like bathroom suites, fixed glass, radiators, kitchen work tops and units."),
                                React.createElement("p", null, "Remember, fixtures and fittings don\u2019t include furniture like sofas or beds."),
                                React.createElement("p", { className: "font-weight-bold banner banner-info" }, "Heads up, to be covered for accidental damage to any fixtures and fittings you\u2019re responsible for, you\u2019ll need to select our optional accidental damage cover.")))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "mb-0" },
                            React.createElement("b", null, "\u00A390,000 for alternative accommodation"),
                            " (if you have to move out because of a fire, flood or water damage)")),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "mb-0" },
                            React.createElement("b", null, "\u00A31,500 for contents in the garden"))),
                    React.createElement("div", { className: "mt-3" },
                        "For full details,",
                        " ",
                        React.createElement("b", { className: "text-decoration-underline cursor-pointer text-blue-1", onClick: function () { return _this.scrollToElement("policyDocumentsOutput"); } }, "see your documents"),
                        "."))));
        };
        _this.setValue = function (value) {
            var currentInteraction = _this.props.engine.getInteraction();
            if (currentInteraction &&
                currentInteraction.factors &&
                currentInteraction.factors.insuredValue !== value) {
                _this.props.onStateChange("factors.insuredValue", value);
                _this.executeEvent("change");
                _this.changelogRecorder.recordPage("change", _this.props, "factors.insuredValue");
            }
        };
        _this.scrollToElement = function (id) {
            var element = document.getElementById(id);
            element.scrollIntoView();
            window.scrollBy(0, -100);
        };
        _this.getMinValue = function () {
            var minValue;
            _this.props.interaction.realEstates[0].bedroomCount >= 4 ? minValue = 10000 : minValue = 5000;
            if (_this.props.interaction.factors.insuredValue < minValue) {
                _this.props.onStateChange("factors.insuredValue", minValue);
            }
            return minValue;
        };
        return _this;
    }
    CoverLimitsWidget.prototype.render = function () {
        return (React.createElement("div", { className: "cover-limits-widget _panel py-5" },
            React.createElement("div", { className: "d-flex justify-content-between align-items-start mb-5" },
                React.createElement("div", null,
                    "How much would it ",
                    React.createElement("b", null, "cost to replace all your contents as new"),
                    "?"),
                React.createElement(InfoModal_1.InfoModal, { className: "ml-3", title: "Contents cover" },
                    React.createElement("p", null,
                        React.createElement("b", null, "Choose a value that will cover the replacement cost of all your contents as new"),
                        ". If you tipped your house upside down, you\u2019d need to count up the value of all your belongings to replace as new \u2013 don\u2019t forget to include things like TV\u2019s, clothes, jewellery etc."),
                    React.createElement("p", null, "Don\u2019t forget to include any items you may specify later as part of this total."),
                    React.createElement("p", null, "Don\u2019t include any contents items owned by your landlord (unless you\u2019re responsible for them)"))),
            React.createElement(FalconSlider_1.FalconSlider, { defaultValue: this.props.engine.getInteraction().factors.insuredValue, step: this.props.interaction.factors.insuredValueStep, minValue: this.getMinValue(), maxValue: this.maxValue, returnValue: this.setValue }),
            React.createElement("div", { className: "dashed-10 my-4" }),
            React.createElement("div", null,
                React.createElement("div", { className: "text-center" },
                    "We'll ",
                    React.createElement("b", null, "cover"),
                    " your ",
                    React.createElement("b", null, "contents in the home against")),
                React.createElement("div", { className: "pt-4 row" },
                    React.createElement("div", { className: "text-center col-3" },
                        React.createElement("img", { src: "/img/Flow-fire.svg", alt: "Fire" }),
                        React.createElement("div", { className: "pt-2" }, "Fire")),
                    React.createElement("div", { className: "text-center col-3" },
                        React.createElement("img", { src: "/img/Flow-theft.svg", alt: "Theft" }),
                        React.createElement("div", { className: "pt-2" }, "Theft")),
                    React.createElement("div", { className: "text-center col-3" },
                        React.createElement("img", { src: "/img/Flow-bad-weather.svg", alt: "Storm or flood" }),
                        React.createElement("div", { className: "pt-2" }, "Storm or flood")),
                    React.createElement("div", { className: "text-center col-3" },
                        React.createElement("img", { src: "/img/Flow-water-leaks.svg", alt: "Water leaks" }),
                        React.createElement("div", { className: "pt-2" }, "Water leaks")))),
            React.createElement("div", { className: "dashed-10 my-4" }),
            React.createElement("div", null,
                React.createElement("div", { className: "text-center" },
                    React.createElement("img", { src: "/img/Flow-pay.svg", alt: "Money" }),
                    React.createElement("div", { className: "pt-3" },
                        React.createElement("b", null, "We'll pay"),
                        " you ",
                        React.createElement("b", null, "up to"))),
                this.renderCheckmarks())));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CoverLimitsWidget.prototype, "changelogRecorder", void 0);
    return CoverLimitsWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CoverLimitsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/CoverLimitsWidget.js
// module id = 2555
// module chunks = 0